export default __webpack_public_path__ + "static/media/danji_cg_03_big.8888f30b.jpg";